import { memo } from 'react';
import garland from '@/assets/product-image-lights.svg';
import './product-image-lights.css';

/** The same garland is decoded once instead of rebuilding SVG definitions per card. */
export const ProductImageLights = memo(function ProductImageLights() {
  return <span className="product-image-lights" aria-hidden="true">
    <img src={garland} className="product-image-garland" alt="" width={320} height={52} loading="lazy" decoding="async" />
  </span>;
});
